var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-password-change d-flex align-items-start justify-content-center"},[_c('AwlModalCard',{attrs:{"title":"Crea nuova password"}},[_c('ResetPasswordChangeForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }